module.exports = __webpack_public_path__ + "../web/img/viendomovies-logo-white.ce9308f8.png";